import Box, { type BoxProps } from '@mui/material/Box';
import Stack, { type StackProps } from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)<BoxProps>(({ theme }) => ({
  aspectRatio: '3.5 / 3',
  borderRadius: theme.spacing(3),
  flex: '0 0 auto',
  overflow: 'hidden',
  position: 'relative',

  '.kmx-car-tile__hero-image': {
    display: 'block',
    height: '100%',
    width: '100%',

    '> img': {
      height: '100%',
      objectFit: 'cover',
      width: '100%',
    },
  },

  '.kmx-car-tile[data-size="xlarge"] &': {
    aspectRatio: 'auto',
    flex: '0 0 50%',
    height: theme.spacing(45),
  },

  '.kmx-car-tile[data-size="large"][data-featured="true"] &': {
    aspectRatio: '16 / 9',
  },

  '.kmx-car-tile[data-size="small"] &': {
    borderRadius: theme.spacing(2),
    flex: '0 0 auto',
    height: theme.spacing(9),
  },

  '.kmx-car-tile__status-badge': {
    left: theme.spacing(1),
    position: 'absolute',
    top: theme.spacing(1),
    zIndex: 2,
  },
}));

export const ActionButtons = styled(Stack)<StackProps>(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  zIndex: 2,

  '.kmx-car-tile[data-size="small"] &': {
    right: 0,
    top: 0,
  },
}));
